import React, { useState, useEffect } from 'react';
import { Modal } from 'modal-components';
import {
  ContractorInput,
  ModalBody,
  SaveButton,
  CustomHeader,
  StyledHeading,
  StyledCloseButton,
  InputWrapper,
} from './AddContractorModal.styles';
import { Icon } from 'bench-internal-theme';

type AddContractorModalProps = {
  closeModal: () => void;
  title: string;
  createContractorData: (name: string) => void;
};

const AddContractorModal = ({
  closeModal,
  title,
  createContractorData,
}: AddContractorModalProps) => {
  const [contractorName, setContractorName] = useState('');
  const inputRef = React.createRef<HTMLInputElement>();
  useEffect(() => {
    if (inputRef?.current) {
      inputRef.current.focus();
    }
  });
  return (
    <Modal size="xLarge">
      <CustomHeader>
        <StyledHeading size={2}>{title}</StyledHeading>
        <StyledCloseButton onClick={closeModal} styleType="secondary" subtle>
          <Icon icon="close" size="medium" />
        </StyledCloseButton>
      </CustomHeader>
      <ModalBody>
        <InputWrapper>
          <ContractorInput
            data-test-id="contractor-name"
            ref={inputRef}
            type="text"
            onChange={event => setContractorName(event.target.value)}
            placeholder="Contractor name"
          />
        </InputWrapper>
        <SaveButton
          onClick={() => {
            createContractorData(contractorName);
            return closeModal();
          }}
          aria-label="Save"
          styleType="primary"
          type="submit"
        >
          Save
        </SaveButton>
      </ModalBody>
    </Modal>
  );
};

export default AddContractorModal;
